import React from 'react'
import Button from '../../../../../components/Button'
import Pill from '../../../../../components/Pill'
import { titleCase } from 'utils'
import { settings } from 'settings'

const PersonalData = ({ profileData, setIsGeneralModalOpen }) => {
  const { name, email, phone, uniList, nickname, account_type } = profileData
  const mappedUniList = uniList?.map(uni => uni?.short_name)
  return (
    <div className="felx flex-col gap-3">
      <span className="text-gray-500 font-bold">Date personale</span>
      <hr className="w-[60%] bg-over-ternary-background mt-1" />

      <div className="grid grid-cols-2 sm:grid-cols-3 mt-4">
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <span className="text-gray-500 font-bold text-xs">TIP CONT</span>
            <span className="font-bold text-over-primary-background text-sm">
              {account_type}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-gray-500 font-bold text-xs">
              Referral Code
            </span>
            <span className="font-bold text-over-primary-background text-sm">
              -
            </span>
          </div>
          {settings.multiple_faculties_enabled ? (
            <div className="flex flex-col gap-1">
              <span className="text-gray-500 font-bold text-xs">
                {titleCase(settings.objective_articulated)} dorită
              </span>
              <span className="font-bold w-full flex flex-wrap text-wrap gap-2 text-over-primary-background text-xs">
                {mappedUniList
                  ?.sort((a, b) => b.length - a.length)
                  ?.map((uni, index) => (
                    <Pill key={`uni-pill-${index}`}>{uni}</Pill>
                  ))}
              </span>
            </div>
          ) : null}
        </div>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <span className="text-gray-500 font-bold text-xs">NICKNAME</span>
            <span className="font-bold text-over-primary-background text-sm">
              {nickname}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-gray-500 font-bold text-xs">EMAIL</span>
            <span className="font-bold text-over-primary-background text-sm">
              {email}
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <span className="text-gray-500 font-bold text-xs">NUME</span>
            <span className="font-bold text-over-primary-background text-xs">
              {name}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-gray-500 font-bold text-xs">NR. TELEFON</span>
            <span className="font-bold text-over-primary-background text-sm">
              {phone}
            </span>
          </div>
        </div>
      </div>
      <Button
        onClick={() => setIsGeneralModalOpen(true)}
        className="bg-btn-primary mt-2 "
      >
        Editeaza
      </Button>
    </div>
  )
}

export default PersonalData
